/*global android_conectam*/
export const movil = (sProceso, oResponse, oError) => {
	let oMovil = {
		"data": {...oResponse, 
			"proceso": sProceso
		},
		"error": oError
	};
	
	try {
		if (window.webkit) {
			window.webkit.messageHandlers.callbackHandler.postMessage(oMovil);
		}
		
		if (android_conectam) {
			android_conectam.callbackHandler(JSON.stringify(oMovil.error), JSON.stringify(oMovil.data));
		}
	}catch(e){
		console.log(e);
	}
};

const initialState = {
	"mensaje": {},
	"identidadValida": false
};

export function movilRdc(state = initialState, action) {
	
	switch (action.type) {
	case "ENVIAR_MENSAJE_MOVIL": 
		return {...state,
			"mensaje": action.mensaje
		};
	case "IDENTIDAD_MOVIL_VALIDA":
		return {...state,
			"identidadValida": true
		};
	case "IDENTIDAD_MOVIL_INVALIDA":
		return {...state,
			"identidadValida": false
		};
	default:
		return state;
	}
}


// WEBPACK FOOTER //
// ./src/app-movil.js